// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1SourceBackup
 */
export interface V1SourceBackup {
  /**
   *
   * @type {string}
   * @memberof V1SourceBackup
   */
  backupName?: string;
  /**
   *
   * @type {string}
   * @memberof V1SourceBackup
   */
  lastUpdatedTime?: string;
  /**
   *
   * @type {string}
   * @memberof V1SourceBackup
   */
  systemSeedURI?: string;
  /**
   *
   * @type {boolean}
   * @memberof V1SourceBackup
   */
  useCatchup?: boolean;
}

/**
 * Check if a given object implements the V1SourceBackup interface.
 */
export function instanceOfV1SourceBackup(
  value: object,
): value is V1SourceBackup {
  return true;
}

export function V1SourceBackupFromJSON(json: any): V1SourceBackup {
  return V1SourceBackupFromJSONTyped(json, false);
}

export function V1SourceBackupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1SourceBackup {
  if (json == null) {
    return json;
  }
  return {
    backupName: json['backupName'] == null ? undefined : json['backupName'],
    lastUpdatedTime:
      json['lastUpdatedTime'] == null ? undefined : json['lastUpdatedTime'],
    systemSeedURI:
      json['systemSeedURI'] == null ? undefined : json['systemSeedURI'],
    useCatchup: json['useCatchup'] == null ? undefined : json['useCatchup'],
  };
}

export function V1SourceBackupToJSON(json: any): V1SourceBackup {
  return V1SourceBackupToJSONTyped(json, false);
}

export function V1SourceBackupToJSONTyped(
  value?: V1SourceBackup | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    backupName: value['backupName'],
    lastUpdatedTime: value['lastUpdatedTime'],
    systemSeedURI: value['systemSeedURI'],
    useCatchup: value['useCatchup'],
  };
}
